import React from 'react';
import { Button, Form } from 'semantic-ui-react';

export default class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            documentNumber: '',
        };

        this.onFilterData = this.onFilterData.bind(this);
    }


    onFilterData() {
        this.props.onFilterData(this.state.name, this.state.documentNumber);
    }


    render() {
        return (
            <div><br />
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Naziv studijskog programa</label>
                            <input
                                value={this.state.name}
                                onChange={(e) => this.setState({ name: e.target.value })}
                                name="name"
                                placeholder="Unesite naziv studijskog programa"
                            />
                        </Form.Field>
                        <Form.Field>
                            {/*<label>Broj odluke</label>*/}
                            {/*<input*/}
                                {/*value={this.state.documentNumber}*/}
                                {/*onChange={(e) => this.setState({ documentNumber: e.target.value })}*/}
                                {/*name="documentNumber"*/}
                                {/*placeholder="Unesite broj odluke"*/}
                            {/*/>*/}
                        </Form.Field>
                    </Form.Group>
                    <Button color="blue" onClick={this.onFilterData}>Filtriraj
                    </Button>
                    <Button basic="true" color="blue" onClick={this.props.filtersOff}>Odustani
                    </Button>
                </Form>
                <br />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/Filters.js